export default __webpack_public_path__ + "d44b1bf3b10805ba270ff3c6f7f85e5b.svg";